/**
 * EsoLab - « Est-ce vraiment un signe de votre défunt ou juste le manque ? »
 * Module interactif Shopify - Bundle JS autonome avec photo de Roseline intégrée
 * Algorithme de discernement en 10 questions & 3 profils
 */

(function() {
  'use strict';

  // Photo de Roseline optimisée et intégrée en base64 WebP (240x240 px)
  const ROSELINE_PHOTO_BASE64 = "data:image/webp;base64,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";

  // Questionnaire (Données exactes du PDF EsoLab)
  const QUESTIONS = [
  {
    "id": 1,
    "kicker": "Question 1 sur 10",
    "theme": "Le contexte d'apparition",
    "question": "Dans quel contexte cet événement ou ressenti s'est-il produit ?",
    "options": [
      {
        "letter": "A",
        "text": "Au détour d'une journée ordinaire, sans que mes pensées soient tournées vers lui/elle."
      },
      {
        "letter": "B",
        "text": "Alors que je me remémorais un souvenir précis ou un moment partagé ensemble."
      },
      {
        "letter": "C",
        "text": "Dans un moment de solitude ou de cafard, où son absence se faisait particulièrement sentir."
      }
    ]
  },
  {
    "id": 2,
    "kicker": "Question 2 sur 10",
    "theme": "La nature de l'expérience",
    "question": "De quoi s'agissait-il concrètement ?",
    "options": [
      {
        "letter": "A",
        "text": "D'un fait extérieur net et insolite (odeur caractéristique soudaine, comportement singulier d'un animal, plume ou objet déplacé)."
      },
      {
        "letter": "B",
        "text": "D'une coïncidence du quotidien qui a fait écho à son souvenir (une chanson, un prénom, une heure miroir)."
      },
      {
        "letter": "C",
        "text": "D'un ressenti purement intérieur : un vide soudain, l'envie irrépressible de lui parler ou d'entendre sa voix."
      }
    ]
  },
  {
    "id": 3,
    "kicker": "Question 3 sur 10",
    "theme": "L'émotion immédiate",
    "question": "Quelle a été votre réaction spontanée à cet instant ?",
    "options": [
      {
        "letter": "A",
        "text": "Un calme instantané et une certitude apaisante, sans angoisse."
      },
      {
        "letter": "B",
        "text": "Une surprise mêlée au besoin immédiat de me demander : « Était-ce lui/elle ? »."
      },
      {
        "letter": "C",
        "text": "Un pincement au cœur et une vague de tristesse liée au manque de sa présence physique."
      }
    ]
  },
  {
    "id": 4,
    "kicker": "Question 4 sur 10",
    "theme": "Les songes et la nuit",
    "question": "Si cela s'est passé durant la nuit ou en rêve, comment était cette expérience ?",
    "canSkip": true,
    "skipText": "Cette situation ne s'est pas produite en songe / Passer cette question",
    "options": [
      {
        "letter": "A",
        "text": "Un songe d'une clarté lumineuse, où la personne était sereine, en bonne santé, et dont l'impact m'a apaisé(e) durablement."
      },
      {
        "letter": "B",
        "text": "Un rêve ordinaire où se mélangeaient des souvenirs du passé et des éléments de ma vie actuelle."
      },
      {
        "letter": "C",
        "text": "Un réveil avec le poids de l'absence, ou des rêves marqués par le regret et la maladie."
      }
    ]
  },
  {
    "id": 5,
    "kicker": "Question 5 sur 10",
    "theme": "La réaction de votre esprit après coup",
    "question": "Quelques heures plus tard, qu'avez-vous ressenti ?",
    "options": [
      {
        "letter": "A",
        "text": "Une tranquillité durable : je n'ai pas ressenti le besoin de chercher à prouver quoi que ce soit."
      },
      {
        "letter": "B",
        "text": "Un va-et-vient constant entre « j'ai envie d'y croire » et « c'est peut-être juste une coïncidence »."
      },
      {
        "letter": "C",
        "text": "Le silence s'est refermé et j'ai eu le sentiment que ce n'était que l'écho de mon propre chagrin."
      }
    ]
  },
  {
    "id": 6,
    "kicker": "Question 6 sur 10",
    "theme": "La dimension matérielle ou sensorielle",
    "question": "Y a-t-il eu un élément concret ou tangible ?",
    "options": [
      {
        "letter": "A",
        "text": "Oui, un fait matériel net, physique ou partagé avec d'autres témoins."
      },
      {
        "letter": "B",
        "text": "C'était un élément banal du quotidien auquel mon regard a spontanément donné du sens."
      },
      {
        "letter": "C",
        "text": "Rien de visible ni de matériel : c'était entièrement intérieur, porté par mon émotion."
      }
    ]
  },
  {
    "id": 7,
    "kicker": "Question 7 sur 10",
    "theme": "Le rythme des ressentis",
    "question": "À quelle fréquence vivez-vous ces moments ?",
    "options": [
      {
        "letter": "A",
        "text": "C'est rare et imprévisible, mais chaque épisode reste gravé avec une netteté totale."
      },
      {
        "letter": "B",
        "text": "Régulièrement : j'ai tendance à être attentif/ve à chaque petit détail de mes journées."
      },
      {
        "letter": "C",
        "text": "C'est arrivé peu de temps après son départ, puis le silence s'est installé depuis des semaines ou des mois."
      }
    ]
  },
  {
    "id": 8,
    "kicker": "Question 8 sur 10",
    "theme": "La sensation globale dégagée",
    "question": "Quelle impression générale vous a laissé cet événement ?",
    "options": [
      {
        "letter": "A",
        "text": "Le sentiment d'un message bienveillant et apaisé, me disant de continuer ma vie."
      },
      {
        "letter": "B",
        "text": "Le besoin d'une confirmation supplémentaire pour être sûr(e) que le lien existe encore."
      },
      {
        "letter": "C",
        "text": "La prise de conscience douloureuse du vide laissé et la nostalgie de son contact."
      }
    ]
  },
  {
    "id": 9,
    "kicker": "Question 9 sur 10",
    "theme": "L'évolution avec le recul",
    "question": "Avec le temps, comment ce souvenir vit-il en vous ?",
    "options": [
      {
        "letter": "A",
        "text": "Il reste un point d'ancrage serein : y repenser m'apporte toujours du réconfort."
      },
      {
        "letter": "B",
        "text": "Je doute souvent de ce que j'ai vécu et j'aimerais revivre la même chose pour en avoir le cœur net."
      },
      {
        "letter": "C",
        "text": "L'effet s'est estompé et le manque a repris toute la place dans mon quotidien."
      }
    ]
  },
  {
    "id": 10,
    "kicker": "Question 10 sur 10",
    "theme": "Votre besoin prioritaire aujourd'hui",
    "question": "Que cherchez-vous avant tout à travers cette démarche ?",
    "options": [
      {
        "letter": "A",
        "text": "Savoir si mon proche a un message précis à me transmettre pour m'aider sur mon chemin."
      },
      {
        "letter": "B",
        "text": "Faire le tri entre les vrais signes et ce que mon mental cherche à interpréter pour se rassurer."
      },
      {
        "letter": "C",
        "text": "Trouver un moyen d'apaiser le manque et apprendre à vivre avec le silence sans me faire du mal."
      }
    ]
  }
];

  // Profils et Textes de restitution (Données exactes du PDF EsoLab, SANS BADGE)
  const PROFILES = {
  "1": {
    "title": "Une véritable tentative de contact de votre proche",
    "climate": "Manifestation spontanée & extérieure",
    "arcProgress": 0.88,
    "blocks": [
      {
        "num": "1",
        "title": "Le décryptage de votre expérience",
        "content": "Vos réponses mettent en lumière les critères fondamentaux du contact authentique en médiumnité : l'effet de surprise totale, une sensation immédiate de calme profond et la présence d'éléments nets qui ne dépendent pas de votre volonté. Vous n'étiez pas en train de chercher ou d'attendre un signal ; cette expérience est venue à vous spontanément, s'inscrivant avec clarté dans votre mémoire."
      },
      {
        "num": "2",
        "title": "Pourquoi le mental cherche à comprendre",
        "content": "Même après avoir vécu une évidence désarmante, il est très fréquent que le doute s'infiltre les jours suivants. Notre esprit cartésien a du mal à accepter ce qui ne s'explique pas par la logique matérielle. Ce tiraillement ne remet pas en cause votre vécu : il témoigne simplement du décalage entre la réalité de l'âme et la rationalité de notre quotidien."
      },
      {
        "num": "3",
        "title": "Notre conseil d’apaisement",
        "content": "Accueillez ce moment comme un cadeau précieux sans chercher à le reproduire artificiellement. Les défunts se manifestent selon leurs propres possibilités et non à la demande. Conservez ce souvenir comme un phare intérieur qui réchauffe votre cœur sans en faire une attente permanente."
      }
    ],
    "regard": "« Dans ma pratique de la canalisation, je constate que les véritables signes arrivent toujours sur la pointe des pieds, quand nous sommes occupés à vivre. Votre proche a su déposer une empreinte de paix au moment où votre cœur était disponible. Gardez cette chaleur en vous : elle est bien réelle. »",
    "gateway": {
      "heading": "Envie d'aller plus loin et de recevoir ses messages ?",
      "intro": "Vous avez perçu une présence tangible. Si vous ressentez le besoin de comprendre ce que votre proche cherche à vous transmettre pour vous aider sur votre chemin, Roseline établit la connexion directe avec lui avec respect et fidélité.",
      "options": [
        {
          "title": "Canalisation directe & Contact défunt",
          "subtitle": "Transmission fidèle des messages de votre proche",
          "modalities": "En Visio ou par Téléphone",
          "buttonText": "Réserver cette séance →",
          "url": "https://esolab.fr/products/roseline-contact-defunt-message-proche?variant=56375049486711"
        }
      ]
    }
  },
  "2": {
    "title": "Entre signe réel et besoin bienveillant d'y croire",
    "climate": "Partagé entre synchronicité et résonance émotionnelle",
    "arcProgress": 0.58,
    "blocks": [
      {
        "num": "1",
        "title": "Le décryptage de votre expérience",
        "content": "Votre vécu se situe à la croisée de deux réalités : il existe très probablement une résonance authentique ou une synchronicité réelle à l'origine, mais le filtre de l'attachement et le besoin viscéral de maintenir le contact vous incitent à sur-interpréter les détails environnants. Votre attention est en permanence en éveil pour guetter la moindre trace de votre proche."
      },
      {
        "num": "2",
        "title": "Pourquoi le mental cherche à comprendre",
        "content": "Face à l'absence, le cerveau humain déteste le vide et cherche naturellement des repères rassurants dans chaque chanson, heure miroir ou coïncidence. Ce n'est ni de la naïveté ni une illusion : c'est l'expression saine et tendre d'un amour qui refuse la rupture et qui tente de construire des ponts invisibles avec ce qu'il a perdu."
      },
      {
        "num": "3",
        "title": "Notre conseil d’apaisement",
        "content": "Ne vous épuisez pas à chercher un sens caché à chaque seconde de vos journées. Trop guetter empêche de recevoir avec sérénité. Offrez-vous le droit d'avoir été touché(e) par cet instant, tout en déposant le besoin absolu de certitude. Le véritable lien n'a pas besoin d'être prouvé en permanence pour exister."
      }
    ],
    "regard": "« Vouloir des signes est le réflexe le plus compréhensible qui soit. Mais trop chercher l'invisible brouille la réception, comme une onde radio saturée. C'est dans les moments de lâcher-prise et de calme intérieur que les messages les plus purs réussissent à nous atteindre. »",
    "gateway": {
      "heading": "Besoin de faire la part des choses avec clarté ?",
      "intro": "Si le doute persiste et que vous souhaitez savoir avec certitude si un message vous attend, Roseline entre en lien avec votre défunt. Elle vous délivre ses ressentis sans complaisance pour vous aider à y voir enfin clair.",
      "options": [
        {
          "title": "Canalisation directe & Contact défunt",
          "subtitle": "Démêler les vrais signes avec discernement",
          "modalities": "En Visio ou par Téléphone",
          "buttonText": "Réserver cette séance →",
          "url": "https://esolab.fr/products/roseline-contact-defunt-message-proche?variant=56375049486711"
        }
      ]
    }
  },
  "3": {
    "title": "L'expression bienveillante de votre mémoire et du manque",
    "climate": "Écho affectif & travail naturel du deuil",
    "arcProgress": 0.3,
    "blocks": [
      {
        "num": "1",
        "title": "Le décryptage de votre expérience",
        "content": "Vos réponses montrent que cette expérience est avant tout la voix de votre propre cœur qui résonne face à l'absence. Le vide ressenti, la nostalgie vive et la force de vos souvenirs occupent actuellement tout l'espace intérieur. Il ne s'agit pas ici d'une manifestation extérieure formelle de votre proche, mais de la preuve bouleversante que votre lien d'amour reste profondément vivant en vous."
      },
      {
        "num": "2",
        "title": "Pourquoi le mental cherche à comprendre",
        "content": "La perte d'un être cher crée un bouleversement complet de nos repères affectifs. Dans les moments de silence ou de solitude, l'esprit tente spontanément de faire revivre la présence manquante pour adoucir la douleur. Cette quête intérieure est une étape normale, saine et nécessaire du chemin de deuil : votre mémoire cherche simplement à prendre soin de votre peine."
      },
      {
        "num": "3",
        "title": "Notre conseil d’apaisement",
        "content": "Ne culpabilisez en aucun cas de ne pas avoir perçu de signe matériel ou éclatant. L'absence de manifestation ne signifie jamais que votre proche vous a oublié(e) ou que le lien est rompu. Votre priorité aujourd'hui n'est pas de chercher des preuves dans l'invisible, mais d'accueillir votre tristesse avec douceur et de vous accorder le temps de cicatriser."
      }
    ],
    "regard": "« Le silence d'un être cher n'est jamais un abandon. Bien souvent, nos défunts respectent notre douleur et attendent que le tumulte du chagrin s'apaise pour ne pas alourdir notre cœur. Le dialogue le plus précieux se fait d'abord en apprenant à retrouver la paix en soi. »",
    "gateway": {
      "heading": "Besoin d'un accompagnement doux et bienveillant ?",
      "intro": "Traverser l'absence et le silence demande du soutien. Que vous ayez besoin de déposer votre peine ou d'interroger la présence de votre proche, Roseline vous accueille avec délicatesse à travers deux accompagnements dédiés :",
      "options": [
        {
          "title": "Accompagnement Deuil & Fin de vie",
          "subtitle": "Un espace d'écoute sensible et chaleureux",
          "description": "Un espace d'écoute sensible et chaleureux pour apaiser la douleur, dénouer les émotions bloquées et avancer vers la sérénité.",
          "modalities": "En Visio ou par Téléphone",
          "buttonText": "Découvrir l'Accompagnement →",
          "url": "https://esolab.fr/products/roseline-accompagnement-deuil-fin-de-vie?variant=56375417995639"
        },
        {
          "title": "Canalisation directe & Contact défunt",
          "subtitle": "Séance Contact Défunt & Message",
          "description": "Si vous ressentez malgré tout le besoin profond d’interroger la présence de votre proche et de savoir si un message vous attend.",
          "modalities": "En Visio ou par Téléphone",
          "buttonText": "Séance Contact Défunt →",
          "url": "https://esolab.fr/products/roseline-contact-defunt-message-proche?variant=56375049486711"
        }
      ]
    }
  }
};

  // SVG Ornaments & Icons
  const SVG_CORNER = `<svg viewBox="0 0 40 40" width="36" height="36" fill="none" stroke="#DFC17B" stroke-width="1.2">
    <path d="M4 36 L4 12 C4 7.6 7.6 4 12 4 L36 4" stroke-linecap="round"/>
    <path d="M8 28 L8 14 C8 10.7 10.7 8 14 8 L28 8" stroke-linecap="round" stroke-width="0.8" opacity="0.6"/>
    <circle cx="4" cy="4" r="2" fill="#DFC17B"/>
    <path d="M12 12 L14 10 L16 12 L14 14 Z" fill="#DFC17B"/>
  </svg>`;
  const SVG_CELESTIAL_FLAME = `<svg class="esolab-celestial-flame" viewBox="0 0 100 100" width="84" height="84" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <radialGradient id="flameHalo" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stop-color="#DFC17B" stop-opacity="0.38"/>
        <stop offset="60%" stop-color="#A4656E" stop-opacity="0.18"/>
        <stop offset="100%" stop-color="#F3E9E5" stop-opacity="0"/>
      </radialGradient>
      <linearGradient id="roseGoldFlameGrad" x1="0%" y1="100%" x2="0%" y2="0%">
        <stop offset="0%" stop-color="#8C4752"/>
        <stop offset="35%" stop-color="#A4656E"/>
        <stop offset="70%" stop-color="#DFC17B"/>
        <stop offset="100%" stop-color="#FFFDFB"/>
      </linearGradient>
      <linearGradient id="innerFlameGrad" x1="0%" y1="100%" x2="0%" y2="0%">
        <stop offset="0%" stop-color="#DFC17B"/>
        <stop offset="50%" stop-color="#F7F1E1"/>
        <stop offset="100%" stop-color="#FFFDFB"/>
      </linearGradient>
      <linearGradient id="goldRayGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stop-color="#DFC17B" stop-opacity="0.85"/>
        <stop offset="100%" stop-color="#C9A75D" stop-opacity="0.25"/>
      </linearGradient>
    </defs>
    <circle cx="50" cy="50" r="46" fill="url(#flameHalo)"/>
    <g stroke="url(#goldRayGrad)" stroke-width="1.2" stroke-linecap="round" opacity="0.85">
      <line x1="50" y1="6" x2="50" y2="15"/>
      <line x1="50" y1="85" x2="50" y2="94"/>
      <line x1="6" y1="50" x2="15" y2="50"/>
      <line x1="85" y1="50" x2="94" y2="50"/>
      <line x1="19" y1="19" x2="25" y2="25"/>
      <line x1="75" y1="75" x2="81" y2="81"/>
      <line x1="19" y1="81" x2="25" y2="75"/>
      <line x1="75" y1="25" x2="81" y2="19"/>
    </g>
    <circle cx="50" cy="50" r="38" stroke="#DFC17B" stroke-width="0.75" stroke-dasharray="2 3" opacity="0.6"/>
    <circle cx="50" cy="50" r="42" stroke="#E4D2CA" stroke-width="0.5" opacity="0.4"/>
    <path d="M50 16 L51.5 21 L56.5 22.5 L51.5 24 L50 29 L48.5 24 L43.5 22.5 L48.5 21 Z" fill="#DFC17B"/>
    <path d="M22 45 L23 48 L26 49 L23 50 L22 53 L21 50 L18 49 L21 48 Z" fill="#C9A75D" opacity="0.8"/>
    <path d="M78 45 L79 48 L82 49 L79 50 L78 53 L77 50 L74 49 L77 48 Z" fill="#C9A75D" opacity="0.8"/>
    <path d="M50 24 C54 36, 68 44, 68 58 C68 68, 59.9 76, 50 76 C40.1 76, 32 68, 32 58 C32 44, 46 36, 50 24 Z" fill="url(#roseGoldFlameGrad)" />
    <path d="M50 38 C52.5 46, 60 51, 60 60 C60 65.5, 55.5 70, 50 70 C44.5 70, 40 65.5, 40 60 C40 51, 47.5 46, 50 38 Z" fill="url(#innerFlameGrad)" />
    <ellipse cx="50" cy="61" rx="4.5" ry="7" fill="#FFFFFF" opacity="0.9"/>
    <circle cx="50" cy="27" r="1.5" fill="#FFFDFB"/>
  </svg>`;
  const SVG_CROWN = `<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 4l3 12h14l3-12-6 7-4-7-4 7-6-7zm3 16h14"/></svg>`;
  const SVG_LEAF = `<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z"/><path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"/></svg>`;
  const SVG_SPARKLE = `<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z"/></svg>`;

  // Module State
  class EsoLabModule {
    constructor(rootEl) {
      this.root = rootEl;
      this.view = 'welcome'; // 'welcome' | 'quiz' | 'loading' | 'result'
      this.currentQuestion = 0;
      this.answers = new Array(10).fill(null);
      this.selectedOption = null;
      this.isTransitioning = false;
      this.computedProfileId = '1';
    }

    init() {
      this.render();
    }

    scrollToTop() {
      if (!this.root) return;
      const rect = this.root.getBoundingClientRect();
      const scrollTop = window.pageYOffset || (document.documentElement && document.documentElement.scrollTop) || 0;
      const targetY = rect.top + scrollTop - 30;
      window.scrollTo({ top: targetY, behavior: 'smooth' });
    }

    startQuiz() {
      this.view = 'quiz';
      this.currentQuestion = 0;
      this.answers = new Array(10).fill(null);
      this.selectedOption = null;
      this.isTransitioning = false;
      this.render();
      this.scrollToTop();
    }

    selectOption(letter) {
      if (this.isTransitioning) return;
      this.isTransitioning = true;
      this.selectedOption = letter;
      this.answers[this.currentQuestion] = letter;

      // Update UI pour l'illumination soyeuse 350ms
      const cards = this.root.querySelectorAll('.esolab-option-card');
      cards.forEach(card => {
        if (card.dataset.letter === letter) {
          card.classList.add('esolab-option-selected');
        } else {
          card.classList.remove('esolab-option-selected');
        }
      });

      setTimeout(() => {
        if (this.currentQuestion < QUESTIONS.length - 1) {
          this.currentQuestion++;
          this.selectedOption = null;
          this.isTransitioning = false;
          this.render();
          this.scrollToTop();
        } else {
          this.finishQuiz();
        }
      }, 350);
    }

    skipQuestion() {
      if (this.isTransitioning) return;
      this.answers[this.currentQuestion] = 'skipped';
      if (this.currentQuestion < QUESTIONS.length - 1) {
        this.currentQuestion++;
        this.selectedOption = null;
        this.render();
        this.scrollToTop();
      } else {
        this.finishQuiz();
      }
    }

    prevQuestion() {
      if (this.isTransitioning) return;
      if (this.currentQuestion > 0) {
        this.currentQuestion--;
        this.selectedOption = this.answers[this.currentQuestion];
        this.render();
        this.scrollToTop();
      } else {
        this.view = 'welcome';
        this.render();
        this.scrollToTop();
      }
    }

    finishQuiz() {
      this.view = 'loading';
      this.render();
      this.scrollToTop();

      // Calcul du profil de discernement
      let countA = 0;
      let countB = 0;
      let countC = 0;

      for (let ans of this.answers) {
        if (ans === 'A') countA++;
        else if (ans === 'B') countB++;
        else if (ans === 'C') countC++;
      }

      // Profiling logic:
      // Profil 1 : Score A >= 5
      // Profil 3 : Score C dominant ou Score A <= 2
      // Profil 2 : Score B dominant ou profil mixte
      let profileId = '2';
      if (countA >= 5) {
        profileId = '1';
      } else if (countA <= 2 && countC >= countB) {
        profileId = '3';
      } else if (countC > countA && countC > countB) {
        profileId = '3';
      } else {
        profileId = '2';
      }

      this.computedProfileId = profileId;

      setTimeout(() => {
        this.view = 'result';
        this.isTransitioning = false;
        this.render();
        this.scrollToTop();
        this.animateArc();
      }, 800);
    }

    restartQuiz() {
      this.startQuiz();
    }

    animateArc() {
      const arc = this.root.querySelector('#esolab-arc-fill');
      if (!arc) return;
      const progress = PROFILES[this.computedProfileId].arcProgress;
      const totalLen = 298.5; // circonférence de l'arc
      const targetOffset = totalLen * (1 - progress);
      arc.style.strokeDasharray = `${totalLen}`;
      arc.style.strokeDashoffset = `${totalLen}`;
      
      requestAnimationFrame(() => {
        setTimeout(() => {
          arc.style.transition = 'stroke-dashoffset 1.4s cubic-bezier(0.25, 1, 0.5, 1)';
          arc.style.strokeDashoffset = `${targetOffset}`;
        }, 100);
      });
    }

    render() {
      if (!this.root) return;

      let innerHtml = '';
      if (this.view === 'welcome') {
        innerHtml = this.renderWelcome();
      } else if (this.view === 'quiz') {
        innerHtml = this.renderQuiz();
      } else if (this.view === 'loading') {
        innerHtml = this.renderLoading();
      } else if (this.view === 'result') {
        innerHtml = this.renderResult();
      }

      this.root.innerHTML = `
        <div class="esolab-card">
          <div class="esolab-corner esolab-corner-tl">${SVG_CORNER}</div>
          <div class="esolab-corner esolab-corner-tr">${SVG_CORNER}</div>
          <div class="esolab-corner esolab-corner-bl">${SVG_CORNER}</div>
          <div class="esolab-corner esolab-corner-br">${SVG_CORNER}</div>
          ${innerHtml}
        </div>
      `;

      this.bindEvents();
    }

    renderWelcome() {
      return `
        <div class="esolab-welcome-view">
          <div class="esolab-celestial-header">
            ${SVG_CELESTIAL_FLAME}
            <span class="esolab-kicker">✦ ESOLAB ✦</span>
          </div>

          <h2 class="esolab-hero-title">Est-ce vraiment un signe de votre défunt ou juste le manque ?</h2>
          <p class="esolab-hero-subtitle">Faites le test en 10 questions pour faire la part des choses avec discernement.</p>

          <div class="esolab-gold-sep">
            <span class="esolab-sep-star">✦</span>
          </div>

          <p class="esolab-hero-intro">
            Après le départ d'un être cher, certains événements troublent notre quotidien. Découvrez si ce que vous vivez est une véritable manifestation de sa part ou l'écho naturel de votre attachement.
          </p>

          <button type="button" class="esolab-btn-gold esolab-start-btn" id="esolab-btn-start">
            ✦ Commencer le test (3 min) ✦
          </button>

          <div class="esolab-reassurance-row">
            <div class="esolab-badge-pill">
              ${SVG_CROWN}
              <span>Exclusivité EsoLab</span>
            </div>
            <div class="esolab-badge-pill">
              ${SVG_LEAF}
              <span>100% gratuit</span>
            </div>
            <div class="esolab-badge-pill">
              ${SVG_SPARKLE}
              <span>Résultat immédiat</span>
            </div>
          </div>
        </div>
      `;
    }

    renderQuiz() {
      const q = QUESTIONS[this.currentQuestion];

      // Collier de 10 perles
      let pearlsHtml = '';
      for (let i = 0; i < 10; i++) {
        let statusClass = 'esolab-pearl-upcoming';
        if (i < this.currentQuestion) statusClass = 'esolab-pearl-completed';
        else if (i === this.currentQuestion) statusClass = 'esolab-pearl-active';
        pearlsHtml += `<div class="esolab-pearl ${statusClass}"></div>`;
      }

      // Options A, B, C
      let optionsHtml = '';
      q.options.forEach(opt => {
        const isSelected = this.selectedOption === opt.letter || this.answers[this.currentQuestion] === opt.letter;
        optionsHtml += `
          <div class="esolab-option-card ${isSelected ? 'esolab-option-selected' : ''}" data-letter="${opt.letter}">
            <div class="esolab-option-badge">${opt.letter}</div>
            <div class="esolab-option-text">${opt.text}</div>
          </div>
        `;
      });

      // Bouton de saut Question 4
      let skipBtnHtml = '';
      if (q.canSkip) {
        skipBtnHtml = `
          <div style="margin: 12px 0;">
            <button type="button" class="esolab-skip-btn" id="esolab-btn-skip">
              ${q.skipText}
            </button>
          </div>
        `;
      }

      return `
        <div class="esolab-quiz-view">
          <div class="esolab-pearls-wrap">
            <div class="esolab-pearls-line"></div>
            ${pearlsHtml}
          </div>

          <div class="esolab-quiz-header">
            <span class="esolab-kicker">✦ QUESTION ${this.currentQuestion + 1} SUR 10 ✦</span>
            <span class="esolab-question-theme">${q.theme}</span>
          </div>

          <h2 class="esolab-question-title">${q.question}</h2>

          <div class="esolab-gold-sep">
            <span class="esolab-sep-star">✦</span>
          </div>

          <div class="esolab-options-list">
            ${optionsHtml}
          </div>

          ${skipBtnHtml}

          <div class="esolab-quiz-nav">
            <button type="button" class="esolab-nav-link" id="esolab-btn-prev">
              ← Question précédente
            </button>
          </div>
        </div>
      `;
    }

    renderLoading() {
      return `
        <div class="esolab-loading-view">
          ${SVG_CELESTIAL_FLAME}
          <h2 class="esolab-loading-text">Analyse de vos ressentis en cours...</h2>
          <p class="esolab-loading-subtext">Écoute attentive de vos réponses & synthèse du discernement spirituel</p>
        </div>
      `;
    }

    renderResult() {
      const p = PROFILES[this.computedProfileId];

      // 3 Blocs d'analyse
      let blocksHtml = '';
      p.blocks.forEach(b => {
        blocksHtml += `
          <div class="esolab-block-card">
            <div class="esolab-block-header">
              <div class="esolab-block-num">${b.num}</div>
              <h3 class="esolab-block-title">${b.title}</h3>
            </div>
            <p class="esolab-block-content">${b.content}</p>
          </div>
        `;
      });

      // Cartes de consultation : médaillon 50x50px cerclé d'or à gauche du titre, AUCUN BADGE
      let gatewayOptionsHtml = '';
      p.gateway.options.forEach(opt => {
        // Formatage harmonieux du libellé avec flèche et protection intégrale sur une seule ligne
        const cleanLabel = opt.buttonText.replace(/\s*→\s*$/, '').trim();
        const btnLabelHtml = `<span class="esolab-btn-label">${cleanLabel}</span><span class="esolab-arrow">→</span>`;

        gatewayOptionsHtml += `
          <div class="esolab-consult-card esolab-consultation-card">
            <div class="esolab-consult-header">
              <div class="esolab-medallion-sm">
                <img src="${ROSELINE_PHOTO_BASE64}" alt="Roseline" width="50" height="50" loading="lazy" />
              </div>
              <div class="esolab-consult-meta">
                <span class="esolab-consult-author">Roseline • Médium chez EsoLab</span>
                <h4 class="esolab-consult-title">${opt.title}</h4>
              </div>
            </div>
            <p class="esolab-consult-desc">${opt.description || opt.subtitle}</p>
            <div class="esolab-consult-tags">
              <span class="esolab-tag">En Visio</span>
              <span class="esolab-tag-sep">•</span>
              <span class="esolab-tag">Par Téléphone</span>
              <span class="esolab-tag-sep">•</span>
              <span class="esolab-tag">Accompagnement bienveillant</span>
            </div>
            <div class="esolab-consult-btn-wrap">
              <a href="${opt.url}" class="esolab-btn-gold esolab-consult-btn" target="_blank" rel="noopener">
                ${btnLabelHtml}
              </a>
            </div>
          </div>
        `;
      });

      // Formatage de la citation de Roseline avec guillemets ornementaux dorés nets
      let rawQuote = p.regard.trim();
      if (rawQuote.startsWith('«')) rawQuote = rawQuote.slice(1).trim();
      if (rawQuote.endsWith('»')) rawQuote = rawQuote.slice(0, -1).trim();
      const quoteFormattedHtml = `<span class="esolab-quote-gold">«</span> ${rawQuote} <span class="esolab-quote-gold">»</span>`;

      return `
        <div class="esolab-result-view">
          <span class="esolab-result-kicker">✦ VOTRE BILAN DE DISCERNEMENT ✦</span>
          <h2 class="esolab-result-title">${p.title}</h2>

          <!-- Arc de discernement SVG bicolore Bois de rose ambré & Or champagne -->
          <div class="esolab-arc-container">
            <svg viewBox="0 0 280 155" class="esolab-arc-svg" width="280" height="155">
              <defs>
                <linearGradient id="esolabArcDual" x1="0%" y1="100%" x2="100%" y2="100%">
                  <stop offset="0%" stop-color="#8C4752" />
                  <stop offset="35%" stop-color="#A4656E" />
                  <stop offset="70%" stop-color="#DFC17B" />
                  <stop offset="100%" stop-color="#F3E5BE" />
                </linearGradient>
                <filter id="esolabArcGlow" x="-20%" y="-20%" width="140%" height="140%">
                  <feGaussianBlur stdDeviation="3" result="blur" />
                  <feMerge>
                    <feMergeNode in="blur" />
                    <feMergeNode in="SourceGraphic" />
                  </feMerge>
                </filter>
              </defs>
              <!-- Arc de fond lin rosé -->
              <path d="M 45 135 A 95 95 0 0 1 235 135" fill="none" stroke="#E4D2CA" stroke-width="10" stroke-linecap="round" />
              <!-- Arc animé bicolore -->
              <path id="esolab-arc-fill" d="M 45 135 A 95 95 0 0 1 235 135" fill="none" stroke="url(#esolabArcDual)" stroke-width="10" stroke-linecap="round" filter="url(#esolabArcGlow)" />
              <!-- Étoile céleste au sommet -->
              <g transform="translate(140, 24)">
                <path d="M0 -7 L1.8 -1.8 L7 0 L1.8 1.8 L0 7 L-1.8 1.8 L-7 0 L-1.8 -1.8 Z" fill="#DFC17B"/>
              </g>
            </svg>
            <div class="esolab-arc-climate-box">
              <span class="esolab-climate-kicker">CLIMAT DU RESSENTI</span>
              <span class="esolab-climate-text">${p.climate}</span>
            </div>
          </div>

          <!-- Les 3 Blocs d'analyse -->
          <div class="esolab-blocks-col">
            ${blocksHtml}
          </div>

          <!-- Encart Le Regard de Roseline avec médaillon ovale cerclé d'or -->
          <div class="esolab-regard-box">
            <div class="esolab-regard-header">
              <div class="esolab-medallion esolab-medallion-lg">
                <img src="${ROSELINE_PHOTO_BASE64}" alt="Roseline, Médium chez EsoLab" width="80" height="88" loading="eager" />
              </div>
              <div class="esolab-regard-kicker"><span class="esolab-star">✦</span> <span class="esolab-regard-title-text">Le Regard de Roseline, Médium</span> <span class="esolab-star">✦</span></div>
            </div>
            <blockquote class="esolab-regard-quote">
              ${quoteFormattedHtml}
            </blockquote>
          </div>

          <!-- Bloc Passerelle vers la consultation -->
          <div class="esolab-gateway-box">
            <h2 class="esolab-gateway-heading">${p.gateway.heading}</h2>
            <p class="esolab-gateway-intro">${p.gateway.intro}</p>
            <div class="esolab-gateway-options">
              ${gatewayOptionsHtml}
            </div>
          </div>

          <!-- Bouton Refaire le test -->
          <div class="esolab-restart-wrap">
            <button type="button" class="esolab-btn-secondary" id="esolab-btn-restart">
              ↺ Refaire le test
            </button>
          </div>
        </div>
      `;
    }

    bindEvents() {
      const startBtn = this.root.querySelector('#esolab-btn-start');
      if (startBtn) {
        startBtn.addEventListener('click', () => this.startQuiz());
      }

      const prevBtn = this.root.querySelector('#esolab-btn-prev');
      if (prevBtn) {
        prevBtn.addEventListener('click', () => this.prevQuestion());
      }

      const skipBtn = this.root.querySelector('#esolab-btn-skip');
      if (skipBtn) {
        skipBtn.addEventListener('click', () => this.skipQuestion());
      }

      const restartBtn = this.root.querySelector('#esolab-btn-restart');
      if (restartBtn) {
        restartBtn.addEventListener('click', () => this.restartQuiz());
      }

      const optionCards = this.root.querySelectorAll('.esolab-option-card');
      optionCards.forEach(card => {
        card.addEventListener('click', (e) => {
          const letter = card.dataset.letter;
          if (letter) this.selectOption(letter);
        });
      });
    }
  }

  // Global initialization function
  window.initEsolabSignesDefunt = function() {
    const root = document.getElementById('esolab-signes-defunt-root');
    if (!root) return;
    if (root.dataset.esolabInitialized === 'true') return;
    root.dataset.esolabInitialized = 'true';

    const app = new EsoLabModule(root);
    app.init();
    window.esolabSignesDefuntApp = app;
  };

  // Support Shopify theme editor events
  document.addEventListener('shopify:section:load', function(e) {
    if (e.target && e.target.querySelector('#esolab-signes-defunt-root')) {
      const root = e.target.querySelector('#esolab-signes-defunt-root');
      root.dataset.esolabInitialized = 'false';
      window.initEsolabSignesDefunt();
    }
  });

  // Auto-init on script load or DOMContentLoaded
  if (document.getElementById('esolab-signes-defunt-root')) {
    window.initEsolabSignesDefunt();
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      window.initEsolabSignesDefunt();
    });
  } else {
    window.initEsolabSignesDefunt();
  }

})();
